import axios from 'axios'
import { Message } from 'element-ui'
import { getToken, removeToken } from '@/utils/auth'
import router from '@/router'

// 创建 axios 实例
const service = axios.create({
  baseURL: "https://xiangyumeeting.top/admin-api",
  timeout: 10000,
  withCredentials: true
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    const token = getToken()
    if (token) {
      config.headers['X-Litemall-Admin-Token'] = token
    }
    return config
  },
  error => {
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    // 如果 errno 存在且不为 0，表示错误
    if (res.errno !== undefined && res.errno !== 0) {
      Message({
        message: res.errmsg || '请求失败',
        type: 'error',
        duration: 5000
      })
      return Promise.reject(new Error(res.errmsg || '请求失败'))
    }
    // 正常返回响应
    return response
  },
  error => {
    console.error('响应错误:', error)
    const res = error.response
    if (res && res.status === 401) {
      removeToken()
      Message({
        message: '登录已过期，请重新登录',
        type: 'warning',
        duration: 3000
      })
      if (router.currentRoute.path !== '/login') {
        router.push('/login')
      }
    } else if (res && res.status === 404) {
      Message({
        message: '接口不存在',
        type: 'warning',
        duration: 3000
      })
    } else {
      Message({
        message: error.message || '网络请求失败',
        type: 'error',
        duration: 5000
      })
    }
    return Promise.reject(error)
  }
)

export default service
